import { omit } from 'lodash';

const addBookSampleComment = (oldBooks, updatedBookData, fieldName = 'bookSample') => updateBooks(oldBooks, updatedBookData, true, fieldName);
const updateBookSampleComment = (oldBooks, updatedBookData, fieldName = 'bookSample') => updateBooks(oldBooks, updatedBookData, false, fieldName);

function updateBooks(oldBooks, updatedBookData, isNewBookSampleComment, fieldName) {
  const {
    bookId,
    comment: updatedComment,
    updatedFeedbackStatus,
    [fieldName]: updatedBookSample,
  } = updatedBookData;
  const books = [...oldBooks];
  const feedbackFieldName = Object.keys(updatedFeedbackStatus || {})[0];
  const bookToUpdate = books.find(book => book._id === bookId);

  if (updatedBookSample) bookToUpdate[fieldName] = updatedBookSample;

  if (!bookToUpdate[fieldName].comments) {
    bookToUpdate[fieldName].comments = [];
  }

  if (isNewBookSampleComment) {
    bookToUpdate[fieldName].comments = bookToUpdate[fieldName].comments
      .map(comment => (comment._id === updatedComment._id ? updatedComment : comment));
  } else {
    bookToUpdate[fieldName].comments.splice(
      updatedComment?.commentPosition,
      0,
      omit(updatedComment, ['commentPosition']),
    );
  }

  if (feedbackFieldName) {
    bookToUpdate[feedbackFieldName].isFeedbackSent = updatedFeedbackStatus[feedbackFieldName].isFeedbackSent;
  }

  const index = books.findIndex(item => item._id === bookId);
  books.splice(index, 1, { ...books[index], ...bookToUpdate });
  return books;
}


export default {
  updateBookSampleComment,
  addBookSampleComment,
};
